<template>
    <svg preserveAspectRatio="none" data-bbox="25.564 10 148.872 179.883" viewBox="25.564 10 148.872 179.883" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="img">
        <g>
            <path d="M165.584 147.883v33H34.416v-33h-8.852v42h148.872v-42h-8.852z"></path>
            <path d="M136.623 121.261l-6.276-6.242-25.918 26.045V10h-8.852v131.066l-25.924-26.047-6.276 6.242 36.626 36.804 36.62-36.804z"></path>
        </g>
    </svg>
</template>

<script>

export default {
  name: 'icon-download',
}
</script>
